// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import unverifiedContainerView  from '../../../../templates/CCM/Unverified/unverifiedContainerView';
import UnverifiedCompositeView from './UnverifiedCompositeView';
import PatientTotalsView from '../PatientList/PatientTotalsView';

// Internal Dependencies - models/collections
import { UnverifiedCollection } from './models/UnverifiedCollection';

export default Marionette.LayoutView.extend({

	regions: {
		'unverifiedContainerView': '.unenrolled-container-view',
		'patientTotals': '.patient-totals-container'
	},

	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.collection = new UnverifiedCollection();
	},

	getTemplate: function() {
		return unverifiedContainerView( this.model );
	},

	onShow: function() {
		this.showChildView( 'unverifiedContainerView', new UnverifiedCompositeView({collection: this.collection}) );
		this.showChildView( 'patientTotals', new PatientTotalsView({collection: this.collection}) );
	}

});
